<template>
  <v-container>
    <router-view></router-view>
  </v-container>
</template>

<script>
import LayoutProductoRegistrar from "@/layouts/productos/layout.registrar.producto";
import LayoutBasic from "@/layouts/LayoutBasic.vue";

import ProductoBuscadorCatalogo from "@/components/producto/buscador/producto.buscador.automatico.vue";
import LayoutRegistrarProducto from "@/layouts/productos/LayoutRegistrarProducto";
import ProductoEmpresaRegistrar from "@/views/producto/gestion/ProductoEmpresaRegistrar.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "producto.registrar",
  components: {
    LayoutProductoRegistrar,
    LayoutRegistrarProducto,
    LayoutBasic,
    ProductoBuscadorCatalogo,
    ProductoEmpresaRegistrar,
  },
  data() {
    return {
      modelMenu: 1,
      loadingButtonRegister: false,
      singleRegister: 0,
      loading: false,
      productoCatalogo: null,

      items: [
        {
          icon: "mdi-arrow-left",
          text: "Listado de productos",
          route: "productos",
        },
        {
          icon: "mdi-folder-plus",
          text: "Nuevo Producto",
          route: "nuevoProducto",
        },

        {
          icon: "mdi-chart-donut",
          text: "Historial",
        },
      ],
    };
  },

  methods: {
    ...mapActions("productos", ["fetch_productos_mas_vendidos"]),
    setProductoCatalogo(productoCatalogo) {
      this.productoCatalogo = productoCatalogo;
    },
    goToRoute(route) {
      this.$router.push({ name: route }).catch(() => {});
    },

    sendRegister() {
      this.$refs.refNuevoProducto.validateForm();
    },
    async fetchProductosMasVendidos() {
      const productos = await this.fetch_productos_mas_vendidos();
    },
    registrarProducto(data) {
      this.axios
        .post(`/productos/p`, data)
        .then((response) => {
          // this.update_product(data);
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: "Producto registrado",
            icon: "mdi-check",
            timeout: 3000,
          });
          this.$router.push("/productos");
          this.fetchProductosMasVendidos();
          this.loading = false;

          // this.$emit("process-product-register-success");
        })
        .catch((e) => {
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "info",
            text: "Problema inesperado",
            icon: "mdi-information",
            timeout: 3000,
          });
          this.loading = false;

          // this.$router.push({
          //   name: "MensajeRegistroError",
          //   params: { error: e.response.data },
          // });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
